import { render, useEffect, useRef } from '@wordpress/element';

import './style.scss';
import Style from './Style';
import { parallaxInit } from './Const/functions';

// Parallax Section
document.addEventListener('DOMContentLoaded', () => {
	const allParallaxSection = document.querySelectorAll('.wp-block-psb-parallax');
	allParallaxSection.forEach(parallaxSection => {
		const { attributes, content } = JSON.parse(parallaxSection.dataset.props);

		render(<ParallaxSection attributes={attributes} content={content} />, parallaxSection);

		parallaxSection?.removeAttribute('data-props');
	});
});

const ParallaxSection = ({ attributes, content }) => {
	const { cId, speed } = attributes;

	const parallaxImgEl = useRef(null);

	useEffect(() => {
		parallaxInit(parallaxImgEl.current, parallaxImgEl.current.parentElement);

		document.addEventListener('scroll', () => {
			parallaxInit(parallaxImgEl.current, parallaxImgEl.current.parentElement);
		});
	}, [])

	return <>
		<Style attributes={attributes} clientId={cId} />

		<div className='psbParallaxImg' data-speed={speed} ref={parallaxImgEl} />

		<div className='psbParallaxSection' dangerouslySetInnerHTML={{ __html: content }} />
	</>;
}